angular.module('app.player.rosterService', [])
  .factory('app.player.rosterService', [
    '$http', '$q',
    function ($http, $q) {
      let service = {
        home: null,
        away: null,
        error: null,
        _debounceRetrieve: _.debounce((deferred, game_id, callback) => {
          "use strict";
          let processData = function (data) {
            if (data.error) {
              service.error = data.error;
            }
            else if (data.roster) {
              service.home = data.roster.home;
              service.away = data.roster.away;

              if (service.current_season_year != data.roster.current_season_year) {
                service.current_season_year = data.roster.current_season_year;
              }

              if (service.client_code != data.roster.client_code) {
                service.client_code = data.roster.client_code;
              }

              angular.forEach(service.home, function (player) {
                player.dteplayerdob = moment(player.dteplayerdob).toDate();
              });

              angular.forEach(service.away, function (player) {
                player.dteplayerdob = moment(player.dteplayerdob).toDate();
              });
            }

            if (typeof callback !== 'undefined') {
              callback();
            }
          };
          $http.get(window.location.api('/games/' + game_id + '/roster'))
            .then(
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                processData(response.data);
                deferred.resolve(response);
              },
              /**
               * @param {HttpResponse} response
               */
              function (response) {
                processData(response.data);
                deferred.resolve(response);
              }
            );
        }, 200),
        retrieve: function (game_id, callback) {
          let deferred = $q.defer();
          service._debounceRetrieve(deferred, game_id, callback);
          return deferred.promise;
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/player/roster/rosterService.js